import { createSingleEntityStore } from '@recruitee/ngrx';
import type { ClaimCounter } from '@recruitee/referrals-types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<{
  counters: ClaimCounter[];
}>()('ReferralsClaimCounters');

export {
  actions as ReferralsClaimCounterActions,
  reducer as ReferralsClaimCounterReducer,
  selectors as ReferralsClaimCounterSelectors,
  namespace as ReferralsClaimCounterNamespace,
};
